import * as React from "react";
import { Typography, Box, Card, useTheme, Slider } from "@mui/material";
import KeyboardArrowRightRoundedIcon from "@mui/icons-material/KeyboardArrowRightRounded";
import { useNavigate } from "react-router";
import moment from "moment";

import RightLeftChecker from "../../../../../utils/RightLeftChecker";
import CustomAvatar from "../../../CustomAvatar";
import CustomCircleButton from "../../../CustomCircleButton";
import AvatarList from "../../../AvatarList";

const NewDetailCart = ({ type, rowData }) => {
  const theme = useTheme();
  const navigate = useNavigate();

  const discussData = () => {
    var data;
    if (type === "opinion") {
      data = rowData.first_topic;
    } else {
      data = rowData.first_converse;
    }
    return data;
  };

  const handleNavigateList = () => {
    if (type === "opinion") {
      navigate(`/table/${rowData.table.pk}/opinions/${rowData.pk}`);
    }
    if (type === "discussion") {
      navigate(`/table/${rowData.table.pk}/discussions/${rowData.pk}`);
    }
  };

  const handleNavigatePost = () => {
    if (type === "opinion") {
      navigate(
        `/table/${rowData.table.pk}/opinions/${rowData.pk}/topics/${
          discussData()?.pk
        }`
      );
    }
    if (type === "discussion") {
      navigate(
        `/table/${rowData.table.pk}/discussions/${rowData.pk}/topics/${
          discussData()?.pk
        }`
      );
    }
  };
  const goToTable = (e, id) => {
    e.stopPropagation();
    navigate(`/table/${id}`);
  };

  return (
    <>
      {discussData() ? (
        <Card
          // onClick={handleNavigate}
          sx={{
            padding: "16px",
            border: "2px solid",
            borderColor: "black.main",
            boxShadow: `0px 4px 0px ${theme.palette.black.main}`,
            borderRadius: "16px",
            marginBottom: "24px",
            cursor: "pointer",
          }}
        >
          <Box sx={{ overflow: "hidden" }}>
            <Box
              onClick={(e) => goToTable(e, rowData.table.pk)}
              sx={{
                display: "flex",
                alignItems: "center",
                mb: type === "opinion" ? "6px" : "46px",
                mt: "2px",
                ml: "2px",
                // direction: RightLeftChecker(rowData.title) ? "rtl" : "ltr",
              }}
            >
              <Box sx={{ position: "relative" }}>
                <CustomAvatar
                  size={26}
                  border={1.5}
                  round={"4px"}
                  src={rowData.table.table_banner}
                />
                {type !== "opinion" && (
                  <Box
                    sx={{
                      position: "absolute",
                      mt: type === "opinion" ? "" : "10px",
                    }}
                  >
                    <AvatarList
                      avatarData={rowData}
                      type='discussion'
                      size={24}
                    />
                  </Box>
                )}

                <Box
                  sx={{
                    height: "70px",
                    borderRight: "2px solid",
                    borderColor: "#BDBDBD",
                    position: "absolute",
                    left: "14px",
                    top: "30px",
                  }}
                ></Box>
                <Box
                  sx={{
                    height: "140px",
                    borderRight: "2px dashed",
                    borderColor: "#BDBDBD",
                    position: "absolute",
                    left: "14px",
                    top: "30px",
                  }}
                ></Box>
              </Box>

              <Typography
                noWrap
                sx={{
                  // textAlign: RightLeftChecker(rowData.title) ? "right" : "left",
                  fontFamily: "Tahrir",
                  fontWeight: "400",
                  lineHeight: "24px",
                  fontSize: "20px",
                  width: "100%",
                  color: "secondary.main",
                  // margin: RightLeftChecker(rowData.title)
                  //   ? "0 8px 0 0"
                  //   : "0 0 0 8px",
                  ml: "8px",
                }}
              >
                {rowData.table.table_title}
              </Typography>
            </Box>

            <Box
              onClick={handleNavigatePost}
              sx={{
                overflow: "hidden",
                display: "flex",
                justifyContent: "space-between",
                mb: "12px",
              }}
            >
              <Box sx={{ alignItems: "center", display: "flex", pt: "6px" }}>
                <CustomAvatar
                  size={64}
                  round={"8px"}
                  src={
                    discussData()?.thumbnail
                      ? discussData()?.thumbnail
                      : discussData()?.author.avatar
                  }
                  iconType='video'
                />
              </Box>
              <Box
                sx={{
                  width: "78%",
                  display: "flex",
                  flexDirection: "column",
                  ml: "8px",
                }}
              >
                <Typography
                  sx={{
                    fontFamily: "Tahrir",
                    fontWeight: "600",
                    lineHeight: "28px",
                    fontSize: "22px",
                    width: "100%",
                    color: "black.main",
                    textAlign: RightLeftChecker(rowData.title)
                      ? "right"
                      : "left",
                    direction: RightLeftChecker(rowData.title) ? "rtl" : "ltr",
                    pt: "4px",
                    pb: "5px",
                    pr: "2px",
                    overflow: "hidden",
                    display: "-webkit-box",
                    WebkitLineClamp: "2",
                    WebkitBoxOrient: "vertical",
                  }}
                >
                  {discussData()?.title}
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    mt: "auto",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      maxWidth: "80px",
                    }}
                  >
                    <Slider
                      aria-label='timeline'
                      min={0}
                      max={1}
                      step={0.001}
                      value={
                        discussData()?.time_watched / discussData()?.duration
                      }
                      sx={{
                        position: "absolute",
                        padding: "0 !IMPORTANT",
                        width: "80px",
                        color: "primary.main",
                        cursor: "default",
                        "& .MuiSlider-track": {
                          border: "none",
                        },
                        "& .MuiSlider-thumb": {
                          display: "none",
                        },
                        "& .MuiSlider-rail": {
                          backgroundColor: "blackDisabled.main",
                          opacity: 0.5,
                        },
                      }}
                    />
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Typography sx={{ color: "mute.main", fontSize: "11px" }}>
                      {moment(rowData.created_at).format("DD/MM/YYYY") +
                        " - " +
                        moment(rowData.created_at).format("h:mm a")}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>

          <Box
            onClick={handleNavigateList}
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography
              sx={{
                display: "flex",
                alignItems: "center",
                fontSize: "16px",
                fontWeight: 600,
                paddingTop: "3px",
                marginRight: "8px",
                color: "secondary.main",
              }}
            >
              {type === "opinion" && rowData.topics_count > 1 ? (
                <>
                  {type === "opinion"
                    ? `and ${rowData.topics_count - 1} more Posts...`
                    : `and ${rowData.converses_count - 1} more Posts...`}
                </>
              ) : (
                "Show post"
              )}
            </Typography>

            <Box sx={{ width: "24px", height: "24px", textAlign: "right" }}>
              <CustomCircleButton
                width='22px'
                height='22px'
                bgColor='white.main'
                hoverBgColor='white.main'
                hoverColor='black.main'
                bShadow={`0px 2px 0px ${theme.palette.black.main}`}
                activeBgColor='black.main'
                activeColor='white.main'
              >
                <KeyboardArrowRightRoundedIcon
                  sx={{ pl: "2px", fontSize: 20 }}
                />
              </CustomCircleButton>
            </Box>
          </Box>
        </Card>
      ) : null}
    </>
  );
};
export default NewDetailCart;
